import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { DeleteInterviewEvaluatorModal } from 'components/modals/DeleteInterviewEvaluatorModal/DeleteInterviewEvaluatorModal'
import { Loader } from 'components/shared/Loader/Loader'
import { Aside } from './layouts/Aside/Aside'
import { Header } from './layouts/Header/Header'
import { Main } from './layouts/Main/Main'

import { InterviewHandlersContext, InterviewStateContext } from './context'
import { useInternalState } from './hooks/useInternalState'

import styles from './InterviewApp.module.scss'

export const InterviewApp = () => {
  const { state, handlers } = useInternalState()

  const {
    evaluator,
    isCategoryStep,
    isDeleteEvaluatorOpen,
    isFetching,
    isSummaryStep,
  } = state
  const { handleDeleteEvaluatorClose, handleDeleteEvaluatorConfirm } = handlers

  if (isFetching) {
    return <Loader isInline />
  }

  return (
    <InterviewStateContext.Provider value={state}>
      <InterviewHandlersContext.Provider value={handlers}>
        <Box className={styles.interview} shouldWrapContent>
          <Header />
          <Box align="center" className={styles.content} justify="center">
            {isCategoryStep || isSummaryStep ? <Aside /> : null}
            <Main />
          </Box>
        </Box>
        <DeleteInterviewEvaluatorModal
          onCancel={handleDeleteEvaluatorClose}
          onClose={handleDeleteEvaluatorClose}
          onConfirm={handleDeleteEvaluatorConfirm}
          isOpen={isDeleteEvaluatorOpen}
          {...{ evaluator }}
        />
      </InterviewHandlersContext.Provider>
    </InterviewStateContext.Provider>
  )
}
